export default __webpack_public_path__ + "static/media/trener11.48b49fbe.png";